import { z } from 'zod';
import { requireFields } from '@utils/form-schema';
import type { IHistoryFamilyModel } from '@/types/history/history-family';

type TFlags = Pick<IHistoryFamilyModel, 'isLiverRegistration' | 'yesValue'>;

export const createHistoryFamilySchema = (model: TFlags) => {
    const yes = String(model.yesValue);
    const liver = model.isLiverRegistration;

    return z.record(z.string(), z.string()).superRefine((data, ctx) => {
        const v = (field: string) => (data as Record<string, string>)[field] ?? '';

        // Condition question + its "which family members" follow-up.
        const condition = (field: string, membersField: string, isRequired = true) => {
            if (isRequired) {
                requireFields(ctx, data, field);
            }

            if (v(field) === yes) {
                requireFields(ctx, data, membersField);
            }
        };

        condition('familyHistoryKidneyDisease', 'familyMembersKidneyDisease');
        condition('familyHistoryLiverDisease', 'familyMembersLiverDisease');
        condition('familyHistoryBowelIssues', 'familyMembersBowelIssues', liver);
        condition('familyHistoryLupusLiver', 'familyMembersLupusLiver', liver);
        condition('familyHistoryHeartDisease', 'familyMembersHeartDisease');
        condition('familyHistoryCad', 'familyMembersCad');
        condition('familyHistoryBloodPressure', 'familyMembersBloodPressure');
        condition('familyHistoryBloodDisorder', 'familyMembersBloodDisorder');
        condition('familyHistoryCancer', 'familyMembersCancer');
        condition('familyHistoryKidneyCancer', 'familyMembersKidneyCancer');
        condition('familyHistoryDiabetes', 'familyMembersDiabetes');
        condition(
            'familyMemberSuddenDeathUnder50',
            'familyMemberSuddenDeathUnder50Description',
            liver,
        );
    });
};
